import React from "react";
import ReactDOM from "react-dom";
import { FormGroup, Overlay, Tooltip } from "react-bootstrap";
import Radio from "../radio/Radio";
import { Field } from "redux-form";
import styles from "./RadioGroup.scss";

class RadioGroup extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.handleEntering = this.handleEntering.bind(this);

    this.props.input.onChange(props.input.value);

    this.state = {
      selected: props.input.value || null
    };
  }

  componentDidMount() {
    if (!this.props.input.value && this.props.defaultValue) {
      this.props.input.onChange(this.props.defaultValue);
    }
  }

  onChange(event) {
    if (!this.props.onChangeRadio) return;
    const vm = this;
    const other = {
      id: this.props.id,
      cat: this.props.category,
      prevVal: this.state.selected
    };
    this.props.onChangeRadio(event, event.target.value, other, () => {
      const value = event.target.value;
      vm.setState({ selected: value }, () => {
        vm.props.input.onChange(value);
      });
    });
  }

  handleEntering(elem) {
    elem.children[0].style.borderRightColor = "#f5ab38";
    elem.children[1].style.backgroundColor = "#f5ab38";
    elem.children[1].style.padding = "9px 13px";
    elem.children[1].style.fontSize = "14px";
    elem.children[1].style.fontFamily = "AvenirNextLTPro-Regular";
  }

  render() {
    const { defaultValue, input } = this.props;
    return (
      <div className={styles.container}>
        <FormGroup
          ref={form => {
            this.target = form;
          }}
          className={styles.radio}
        >
          <Field
            name={input.name}
            component={Radio}
            type="radio"
            value="MUST_HAVE"
            text="Must-Have"
            handleChange={this.onChange}
            checked={
              input.value !== "NICE_HAVE" &&
              (input.value === "MUST_HAVE" || defaultValue === "MUST_HAVE")
            }
          />
          <Field
            name={input.name}
            component={Radio}
            type="radio"
            value="NICE_HAVE"
            text="Nice to Have"
            handleChange={this.onChange}
            checked={
              input.value === "NICE_HAVE" || defaultValue === "NICE_HAVE"
            }
            marginLeft={true}
          />
        </FormGroup>
        <Overlay
          placement="right"
          show={input.value === "" && !this.props.submitting}
          container={this}
          target={() => ReactDOM.findDOMNode(this.target)}
          onEntering={this.handleEntering}
        >
          <Tooltip
            className={styles.tooltip}
            id="required-checkbox-radio-group"
          >
            Selection required
          </Tooltip>
        </Overlay>
      </div>
    );
  }
}

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/common/radioGroup/RadioGroup.js